import { render, staticRenderFns } from "./actualites.vue?vue&type=template&id=64e10cf4"
import script from "./actualites.vue?vue&type=script&lang=js"
export * from "./actualites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports